import React, { useEffect, useState } from "react";
import { formatTime } from "../merchantFooter/operatingHours";
import CloseIcon from "@/components/_icons/closeIcon";
import { RegularModal } from "../modals/modals";

export const BusinessHoursModal = ({
  isOpen,
  onRequestClose,
  daysOfWeek,
  businessHours,
  timezone,
  isRestaurantMerchant,
}: any) => {
  const [currentDay, setCurrentDay] = useState<string>("");
  const modalHeaderText = isRestaurantMerchant
    ? "Ordering hours"
    : "Business hours";

  useEffect(() => {
    const today = new Date()
      .toLocaleDateString("en-US", { weekday: "long" })
      .toLowerCase();
    setCurrentDay(today);
  }, [isOpen]);

  return (
    <RegularModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="bg-opacity-75"
    >
      <div className="bg-white sm:rounded-lg shadow-lg w-[100%] h-[100%] sm:h-auto sm:w-[425px] mx-auto overflow-hidden">
        <div className="flex justify-between items-center px-6 pt-6">
          <h2 className="pt-4 text-4xl text-[32px] font-medium text-[#373737]">
            {modalHeaderText}
          </h2>
          <button
            onClick={onRequestClose}
            className="text-gray-600 hover:text-gray-900"
          >
            <CloseIcon />
          </button>
        </div>
        <div
          className={[
            "flex",
            "flex-col",
            "justify-center",
            "items-start",
            "py-8",
            "px-6",
          ].join(" ")}
        >
          {businessHours &&
            daysOfWeek.map((day: any) => (
              <div
                key={day}
                className={["flex flex-row justify-between w-full"].join(" ")}
              >
                <span
                  className={[
                    "capitalize",
                    currentDay === day ? "font-medium" : "text-[#727272]",
                  ].join(" ")}
                >
                  {day}
                </span>
                <div className="flex flex-col text-end">
                  {businessHours?.[day].length > 0 ? (
                    businessHours?.[day].map((timeSlot: any, index: number) => (
                      <span
                        key={index}
                        className={[
                          "pb-4",
                          currentDay === day ? "font-medium" : "text-[#727272]",
                        ].join(" ")}
                      >
                        {formatTime(timeSlot.start)} -{" "}
                        {formatTime(timeSlot.end)} {timezone}
                      </span>
                    ))
                  ) : (
                    <span className="pb-4 text-[#727272]">Closed</span>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </RegularModal>
  );
};
